import './bootstrap_common';
import { queryString, } from 'utils/window';
import initAds from 'initializers/ads/initAds';
import initTopPosts from 'initializers/initTopPosts';
import { initDfpDynamicSlot, } from 'config/adInjectedDfpDynamicSlotConfig';
import initBrowsi from 'initializers/initBrowsi';
import initScreenClassifer from 'initializers/deviceScreenClassifier';
import initDomainClassifier from 'initializers/domainClassifier';
import initPageTemplateClassifier from 'initializers/pageTemplateClassifier';
import initAnalytics from 'initializers/analyticsInitializer';
import 'initializers/analyticsScrollEventInitializer';
import initDocumentBodyClassSetter from 'initializers/documentBodyClassSetter';
import initTaboola from 'initializers/taboolaInitializer';
import 'initializers/providersInitializer';
import initLocaleCookieInitializer from 'initializers/localeCookieInitializer';
import mountFantasyComponent from 'components/fantasy/fantasyMounter';
import mountFacebookBot from 'components/facebook_bot/facebookBotMounter';


const { noThirdParty, } = queryString;

function initInitializers(){
  initScreenClassifer();
  initDomainClassifier();
  initPageTemplateClassifier();
  initTopPosts();
  initAnalytics();
  initDocumentBodyClassSetter();
  initLocaleCookieInitializer();
}

function initGoogleAds(){
  initDfpDynamicSlot();
  initAds();
}

function initThirdParty(){
  initGoogleAds();
  initTaboola();
  initBrowsi();
  mountFantasyComponent();
  mountFacebookBot();
}

function init(){
  initInitializers();
  if (!noThirdParty) {
    initThirdParty();
  }
}

init();


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/bootstrap_post_page.js